import { createGuid, IDictionary } from '@bimser/core';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { Map } from 'immutable';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { IRule } from './entities';
import { convertEvent } from './convertEvent';
import { convertRule } from './convertRule';

export function convertRules(
	rules: IDictionary<RuleEngineLegacyEntities.IRule>,
	formData: Map<string, LayoutCreatorEntities.LayoutItem>,
	getFactKeys: (factKey: string) => void
): IRule[] {
	const returnRules: IRule[] = [];

	Object.keys(rules).forEach(key => {
		const rule = rules[key];

		if (rule.enabled) {
			if (rule.statements?.length) {
				rule.statements.forEach(s => {
					if (s.actions?.length) {
						if (s.typeName === 'ElseStatement') {
							returnRules.push({
								conditions: {
									any: []
								},
								event: convertEvent(s.actions, rule, getFactKeys),
								id: rule.id,
								statement: s
							});
						} else {
							returnRules.push(
								convertRule({
									rule,
									statement: s,
									conditionGroup: s.conditionGroup,
									actions: s.actions,
									formData,
									getFactKeys
								})
							);
						}
					}
				});
			}

			let indirectyUsedAction: RuleEngineLegacyEntities.IBaseAction[] = [];

			let unusedActions = rule.actions.filter(action => {
				let actionUsed = false;

				if (rule.statements?.length) {
					actionUsed = rule.statements.some(s => s.actions.some(a => a.id === action.id));
				}

				if (action.typeName === 'ConfirmationAction') {
					const approvalActions = (action as RuleEngineLegacyEntities.IShowMessageAction)
						.approvalActions;
					const rejectionActions = (action as RuleEngineLegacyEntities.IShowMessageAction)
						.rejectionActions;

					indirectyUsedAction = [
						...indirectyUsedAction,
						...approvalActions,
						...rejectionActions
					];
				}

				return !actionUsed;
			});

			unusedActions = unusedActions.filter(
				action => !indirectyUsedAction.find(i => i.id === action.id)
			);

			if (unusedActions?.length) {
				returnRules.unshift({
					conditions: {
						any: []
					},
					event: convertEvent(unusedActions, rule, getFactKeys),
					id: rule.id,
					statement: RuleEngineLegacyEntities.BaseStatementFactoryFromJS({
						id: createGuid(),
						actions: unusedActions,
						enabled: true,
						typeName: 'IfStatement'
					}).toJS()
				});
			}
		}
	});

	return returnRules;
}
